import { SingleEventHandler } from "../integration";
import type { SingleEventHandlerInterface } from "../integration/SingleEventHandler";

interface PageHandlerInterface {
  navigate: SingleEventHandlerInterface["trigger"];
  onChange: (
    callback: (page: string, ...args: Array<Record<string, string>>) => void,
  ) => void;
  stopOnChange: SingleEventHandlerInterface["stopListening"];
}

export const PageHandler = (): PageHandlerInterface => {
  const singleEventHandler = SingleEventHandler();
  return {
    navigate: singleEventHandler.trigger,
    onChange: singleEventHandler.listen as PageHandlerInterface["onChange"],
    stopOnChange: singleEventHandler.stopListening,
  };
};
